var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBluetooth = function SvgBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.771 2.034a.6.6 0 0 1 .653.13L17.13 6.87a.6.6 0 0 1 0 .848L12.848 12l4.282 4.283a.6.6 0 0 1 0 .848l-4.706 4.706a.6.6 0 0 1-1.023-.423v-7.965L7.718 17.13a.6.6 0 0 1-.847-.848l4.28-4.283-4.28-4.28a.6.6 0 0 1 .847-.85l3.683 3.683V2.588a.6.6 0 0 1 .37-.554m.83 17.93 3.256-3.258-3.257-3.258zm0-9.413 3.256-3.258L12.6 4.037z"
  })));
};
export default SvgBluetooth;